export const testimonials = [
  {
    quote: 'Lo que más me gusta es tener los temas separados y organizados. Cuando me surge una duda, puedo buscar el capítulo correspondiente sin tener que revisar un montón de páginas diferentes.',
    name: 'Camila Rodríguez',
    role: 'Madre primeriza',
    city: 'Córdoba',
  },
  {
    quote: 'Las explicaciones visuales son lo que más valoro. Poder consultar los cuidados cotidianos de manera sencilla hace que el material resulte mucho más práctico.',
    name: 'Agustina Pereyra',
    role: 'Mamá de un recién nacido',
    city: 'Rosario',
  },
  {
    quote: 'Los planificadores y las listas me resultan muy útiles para organizar los controles, las cosas que necesito preparar y las preguntas para el pediatra.',
    name: 'Julieta Morales',
    role: 'Madre primeriza',
    city: 'Mendoza',
  },
  {
    quote: 'Me gustó que no se enfoque solamente en el bebé. También incluye información sobre el posparto y herramientas para organizar las responsabilidades familiares.',
    name: 'Micaela Suárez',
    role: 'Mamá primeriza',
    city: 'La Plata',
  },
];
